<!--
 * Created by laixinyu on 2017/3/31.
-->

<template>
    <!-- <transition :name="'fadeToast'"> -->
        <div class="toast-container" v-if="showText">
            <div :class="['toast fs-14', localStatus]">
            	<div><span v-html="showText"></span></div>
        	</div>
        </div>
    <!-- </transition> -->
</template>

<style lang='scss'>
    @import "../../scss/function";

    .toast-container {
        position: fixed;
        display: flex;
        top: 50%;
        left: 0;
        right: 0;
        z-index: 9999;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transform: translate(0, -50%);
        white-space: pre-line;
        .toast {
            padding: topx(30rem);
            margin-bottom: topx(10rem);
            max-width: topx(400rem);
            line-height: 1.14;
            background: rgba(0, 0, 0, .6);
            color: #fff;
            /* font-size: 14px; */
            border-radius: 5px;
            text-align: center;
            overflow: hidden;
            p{
                line-height: topx(36rem);
            }
            &:last-child {
                margin-bottom: 0;
            }
            &.success {
                width: topx(240rem);
                height: auto;
                &:before{
                    content:'';
                    display: block;
                    width: topx(200rem);
                    height:topx(200rem);
                    margin:0 auto;
                    background: url('../../assets/icon/toast-success.svg') no-repeat center;
                    background-size: 60%;
                }
            }
            &.warning{
                width: topx(240rem);
                height: auto;
                &:before{
                    content:'';
                    display: block;
                    width: topx(200rem);
                    height: topx(200rem);
                    margin:0 auto;
                    background: url('../../assets/toast-tis.png') no-repeat center;
                    background-size: topx(96rem) topx(96rem);
                }
            }
        }
    }
</style>

<script>
    export default {
        name: 'yxl-toast',
        props: {
            propText: {
                required: true,
                type: String,
                default: '',
            },
            status:{
                type: String,
                default: ''
            },
            propTime: {
                type: [Number, String],
                default: 1300
            },
            istTisImg:{
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                showText: '',
                localStatus:'',
                showToast: false,
            }
        },
        mounted() {
            this.showText = this.propText;
        },
        watch: {
            'propText': function (newVal, oldVal) {
                const that = this;
                if (newVal != '') {
                    that.showText = newVal;
                    that.localStatus = that.status;
                    that.timeOutFn();
                }
            },
        },
        methods: {
            timeOutFn(){
                const that = this;
                setTimeout(() => {
                    that.showText = '';
                    that.localStatus = '';
                    that.$emit('toastEnd');
                }, that.propTime)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/yxlToast.vue